import React from "react";
import { Video } from "components/ui";

function Videos({ videos }) {
  return videos.map((url, index) => <Video key={index} url={url} />);
}

export default Videos;
